import { makeAutoObservable } from "mobx";
import { IdentifiableMap } from "../../collections";
import { InternalParameterSet, ParameterSet } from "../Menu";
import { CustomParameterInstances } from "../ProductInstance";
/**
 * Provides ParameterSet from ProductInstanceCreator state.
 * Similar to ParameterScopeProvider but works with creator state
 * (mutable CustomParameterInstanceCreators) instead of finalized ProductInstance.
 */
export class CreatorScopeProvider {
    constructor(fulfillmentInstructions, isSplit, customParameterInstanceCreators) {
        this.fulfillmentInstructions = fulfillmentInstructions;
        this.isSplit = isSplit;
        this.customParameterInstanceCreators = customParameterInstanceCreators;
        makeAutoObservable(this);
    }
    get parameterSet() {
        const customParameterInstances = IdentifiableMap.fromIterable("typeId", this.customParameterInstanceCreators.objects.map((c) => c.customParameterInstance));
        return new ParameterSet({
            internal: new InternalParameterSet({
                fulfillmentMethod: this.fulfillmentInstructions.fulfillmentMethod,
                splitToHalves: this.isSplit,
            }),
            custom: CustomParameterInstances.toCustomParameterSet(customParameterInstances),
        });
    }
}
